import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './FeaturesList.css';

const cx = classnames.bind(styles);

function FeaturesList({ className }) {
    const classes = cx({
        root: true,
        [className]: className
    });

    return (
        <ul className={classes}>
            <li>
                <Icon name='check' />
                <span><strong>Voice & text recording</strong> preserved in their exact words</span>
            </li>
            <li>
                <Icon name='check' />
                <span><strong>Questions that adapt</strong> to the stories</span>
            </li>
            <li>
                <Icon name='check' />
                <span><strong>Zero tech skills</strong> needed to answer</span>
            </li>
            <li>
                <Icon name='check' />
                <span><strong>Beautiful Ebook</strong> for the <strong>family</strong></span>
            </li>
            <li>
                <Icon name='check' />
                <span><strong>Private & secure</strong> storage</span>
            </li>
        </ul>
    );
}

FeaturesList.propTypes = {
    className: PropTypes.string
};

FeaturesList.defaultProps = {
    className: ''
};

export {
    FeaturesList
};
